module.exports = __webpack_public_path__ + "static/map-25359dc5a1f448af7b57ae2807a2d350.png";